import { render } from "./YearMaster.vue?vue&type=template&id=6e52984d&scoped=true"
import script from "./YearMaster.vue?vue&type=script&lang=js"
export * from "./YearMaster.vue?vue&type=script&lang=js"

import "./YearMaster.vue?vue&type=style&index=0&id=6e52984d&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e52984d"]])

export default __exports__